export const breadcrumbConstants = {
    REQUEST_UPDATE_BREADCRUMB: 'REQUEST_UPDATE_BREADCRUMB',
    REQUEST_UPDATE_LAST: 'REQUEST_UPDATE_LAST'
};